import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/HomeScreen"),
    meta: {
      enterClass: "animate__animated animate__faster animate__fadeInRight",
      leaveClass: "animate__animated animate__faster animate__fadeOutRight",
    },
  },
  {
    path: "/get-invite",
    name: "getInvite",
    component: () => import("@/views/GetInviteScreen"),
    meta: {
      enterClass: "animate__animated animate__faster animate__fadeInRight",
      leaveClass: "animate__animated animate__faster animate__fadeOutRight",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
